module.exports = __webpack_public_path__ + "img/book_img.575d199f.svg";